/*
    Used to control the browser URL
 */
import {createBrowserHistory} from 'history';

export const history = createBrowserHistory();
